import Button from 'components/shared/button/button';
import Image from 'components/shared/image';
import RichText from 'components/shared/richtext';
import styles from './doubleCta.module.scss';

const DoubleCta = ({ data, locale }) => {
  const { ctas } = data;

  return (
    <section id="sectionDoubleCta">
      <div className={styles.ctasWrapper}>
        <div className={styles.ctaOne}>
          <Image
            className={styles.ctaImage}
            src={ctas[0]?.media?.image}
            layout="fill"
            loading="lazy"
            sizes="(max-width: 899px) 100vw, 40vw"
          />
          <h3 className={styles.ctaHeadline}>{ctas[0]?.headline}</h3>
          {ctas[0]?.subtitle && <p className={styles.ctaSubheading}>{ctas[0].subtitle}</p>}
          <RichText className={styles.ctaBody} text={ctas[0]?.body?.json} />
          {ctas[0]?.button && (
            <Button className={styles.ctaButton} locale={locale} button={ctas[0]?.button} />
          )}
        </div>
        <div className={styles.ctaTwo}>
          <Image
            className={styles.ctaImage}
            src={ctas[1]?.media.image}
            layout="fill"
            loading="lazy"
            sizes="(max-width: 899px) 100vw, 40vw"
          />
          <h3 className={styles.ctaHeadline}>{ctas[1]?.headline}</h3>
          {ctas[1]?.subtitle && <h3 className={styles.ctaSubheading}>{ctas[1]?.subtitle}</h3>}
          <RichText className={styles.ctaBody} text={ctas[1]?.body?.json} />
          {ctas[1]?.button && (
            <Button className={styles.ctaButton} locale={locale} button={ctas[1]?.button} />
          )}
        </div>
      </div>
    </section>
  );
};

export default DoubleCta;
